$(function () {
  new Reservation("#form-1", {
    siteId: 13,
    contentName: "1V1定制方案",
  });

  new Reservation("#form-2", {
    siteId: 13,
    contentName: "预约到校咨询",
  });

  // 课程轮播
  new Swiper(".course-slider", {
    autoplay: true,
    loop: true,
    slidesPerView: 2,
    centeredSlides: true,
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 145,
      depth: 250,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });

  // 老师轮播图
  new Swiper(".teacher-slider", {
    autoplay: true,
    spaceBetween: 10,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    thumbs: {
      swiper: {
        el: ".teacher-thumbs-slider",
        slidesPerView: 7,
      },
    },
  });
});
